






















import Vue, { PropType } from 'vue'
import Button from '@/types/components/Button.interface'
export default Vue.extend({
    props: {
        opacity: {
            type: String,
            default: '0.4'
        },
        borderRadius: {
            type: String,
            default: '0px 0px 5px 5px'
        },
        buttons: {
            type: Array as PropType<Button[]>,
            required: true
        },
        open: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        backgroundColor() {
            //  Assemble the color using opacity setting (we do this, rather than setting opacity directly, to avoid a conflict with the Vuetify sliding animation)
            const c = `rgba(0,0,0,${this.opacity})`

            //  Return the background color
            return c
        }
    },
    methods: {
        disabledPopup(): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Button Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        onclick(btn: Button): void {
            //  Check if our button is disabled
            const disabled = btn.disabledPopup

            //  If it is then return our pop up
            if (disabled) return this.disabledPopup()

            //  Else, just use our callback
            btn.callback()
        }
    }
})
